import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-asc-icon",
  "use": "icon-asc-icon-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-asc-icon\"><defs><style type=\"text/css\"></style></defs><path d=\"M209.205104 703.69902c-9.572398 0-12.391722-6.018064-6.263914-13.371542L500.701725 332.935742c6.127809-7.354502 16.15355-7.354502 22.281359 0l297.760535 357.391736c6.127809 7.354502 3.308484 13.371542-6.263914 13.371542L209.205104 703.69902z\" p-id=\"1419\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol